
import React from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { Calendar } from "lucide-react";

const NewCallToAction = () => {
  const { language } = useLanguage();

  const content = {
    fr: {
      buttonText: "Créer leur cagnotte cadeau",
      calendarButtonText: "Être accompagné par un conseiller"
    },
    en: {
      buttonText: "Offer more than a gift",
      calendarButtonText: "Be guided by an advisor"
    },
    de: {
      buttonText: "Biete mehr als ein Geschenk",
      calendarButtonText: "Von einem Berater begleitet werden"
    }
  };

  const handleCalendlyClick = () => {
    window.location.href = "https://calendly.com/legatia/15min";
  };

  return (
    <section className="section-padding bg-gradient-to-r from-legatia-orange/30 via-legatia-yellow/20 to-legatia-red/30 py-28 relative overflow-hidden">
      {/* Enhanced background decoration */}
      <div className="absolute top-0 right-0 w-80 h-80 bg-legatia-yellow/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-legatia-orange/20 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="section-title animate-fade-in">
            Soyez présent dans 
            <span className="gradient-text"> les moments qui comptent</span>
          </h2>
          
          <p className="text-xl md:text-2xl text-gray-700 mb-12 animate-fade-in" style={{ animationDelay: "0.2s" }}>
            Le temps vous sépare de ces moments importants, mais l'émotion peut traverser les années.
            Créez aujourd'hui une connexion qui transcende le temps et offrez un cadeau d'une valeur inestimable.
          </p>
          
          <div className="bg-white/90 p-8 rounded-xl shadow-lg mb-12 transform hover:scale-[1.01] transition-all animate-fade-in" style={{ animationDelay: "0.4s" }}>
            <p className="text-xl md:text-2xl font-medium italic">
              "Les mots du passé deviennent les émotions du présent et les fondations de l'avenir."
            </p>
          </div>
          
          <div className="flex flex-col md:flex-row items-center justify-center gap-4">
            <Button 
              className="btn-primary text-xl px-12 py-7 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all animate-fade-in"
              style={{ animationDelay: "0.6s" }}
              onClick={() => window.location.href = "https://app.getlegatia.ch/"}
            >
              {content[language].buttonText}
            </Button>
            
            <Button 
              variant="outline"
              className="text-xl px-12 py-7 border-2 border-legatia-orange text-legatia-orange hover:bg-legatia-orange hover:text-white transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1 animate-fade-in"
              style={{ animationDelay: "0.6s" }}
              onClick={handleCalendlyClick}
            >
              <Calendar className="mr-2 h-5 w-5" />
              {content[language].calendarButtonText}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewCallToAction;
